import React, { useState, useEffect } from 'react';
import { Share } from 'react-bootstrap-icons';
import { utcToZonedTime, format } from 'date-fns-tz';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

const ShareButton = ({ todaysRiddle }) => {
  const [buttonText, setButtonText] = useState('Share');
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [copyText, setCopyText] = useState('');
  const [todaysResult, setTodaysResult] = useState(null);

  const buttonStyle = {
    backgroundColor: 'rgb(125, 121, 210)',
    color: 'white',
    padding: '15px 30px',
    border: 'none',
    borderRadius: '25px',
    cursor: 'pointer',
    fontSize: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold'
  };

  const iconStyle = {
    marginRight: '10px',
  };

  useEffect(() => {
    const riddleStats = localStorage.getItem('riddleStats');
    if (riddleStats) {
        const games = JSON.parse(riddleStats);
        const lastGameKey = Object.keys(games).sort().pop(); 
        setTodaysResult(games[lastGameKey]); 
    }
  }, []); 

  const handleShare = () => {
    const date = new Date();
    const newYorkTime = utcToZonedTime(date, 'America/New_York');
    const formattedDate = format(newYorkTime, 'MM/dd/yyyy', { timeZone: 'America/New_York' });
    const textToCopy = "Ridella " + formattedDate;
    console.log(todaysResult)
    setButtonText('Copied!');
    setTimeout(() => setButtonText('Share'), 3000);
  
    const createEmojiString = (guesses, solved) => {
      const greenSquare = "🟩";
      const greySquare = "⬜";
      const yellowSquare = "🟨";
      let emojiString = "💡 ";
      for (let i = 1; i <= 4; i++) {
        if (i === guesses & solved===true) {
            emojiString += greenSquare + " "; 
        } else { 
            emojiString += (i <= guesses ? yellowSquare : greySquare) + " "; 
        }
      }
      emojiString += "\n\nhttps://ridella.xyz";
      return emojiString;
    };
    
    const emojiString = createEmojiString(todaysResult.guesses, todaysResult.solved, todaysRiddle);
  
    if (/Firefox/i.test(navigator.userAgent) && /Mobi|Android/i.test(navigator.userAgent)) {
      console.log('Firefox on mobile: Fallback to clipboard copy');
      fireFoxCopy(textToCopy + "\n" + emojiString);
    } else if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(textToCopy + "\n" + emojiString).then(function() {
        console.log('Copying to clipboard was successful!');
        if (!(/Mobi|Android/i.test(navigator.userAgent))) {
          alert(`Copied to clipboard: \n\n${textToCopy + "\n" + emojiString}`);
        }
      }, function(err) {
        console.error('Could not copy text: ', err);
      });
    } else if (navigator.share) {
      navigator.share({
        title: 'Ridella',
        text: textToCopy + "\n" + emojiString,
      })
      .then(() => console.log('Successful share'))
      .catch((error) => console.log('Error sharing', error));
    } else {
      console.log('Fallback: Copy to clipboard');
      fallbackCopyTextToClipboard(textToCopy + "\n" + emojiString);
      // alert('Please manually copy the following text:\n\n' + textToCopy + "\n" + emojiString);
    }

  };

  const fireFoxCopy = (text) => {
    var textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      var successful = document.execCommand('copy');
      if (successful) {
        alert('Copied to clipboard');
      } else {
        throw new Error('Failed to copy');
      }
    } catch (err) {
      console.error('Fallback: Could not copy text: ', err);
    } finally {
      document.body.removeChild(textArea);
    }
  }

  const fallbackCopyTextToClipboard = (text) => {
    setCopyText(text);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };
  
  const modalBody = (
    <Box sx={{ 
      position: 'absolute', 
      top: '50%', 
      left: '50%', 
      transform: 'translate(-50%, -50%)', 
      bgcolor: 'background.paper', 
      boxShadow: 24, 
      p: 4,
      width: '80%',
      maxHeight: '70vh',
      overflow: 'auto'
    }}>
      <Typography id="modal-modal-title" variant="h6" component="h2">
        Copy This Text
      </Typography>
      <textarea value={copyText} readOnly style={{width: "100%", height: "200px"}}></textarea>
      <Button onClick={closeModal}>Close</Button>
    </Box>
  );

  return (
    <div>
      <button style={buttonStyle} onClick={() => { handleShare(); shareButtonCounter(); }}>
        <Share style={iconStyle} />
        {buttonText}
      </button>
      <Modal
        open={modalIsOpen}
        onClose={closeModal}
        aria-labelledby="modal-modal-title"
      >
        {modalBody}
      </Modal>
    </div>
  );
};

function shareButtonCounter() {
  const apiUrl = "https://7z7przcw81.execute-api.us-east-1.amazonaws.com/prod";
  const params = {
      action: "shareButton"
  };
  fetch(apiUrl, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(params)
  })
  .then(response => response.json())
  .catch(error => {
    console.error('Error incrementing counter:', error);
  });
}

export default ShareButton;
